/**
 * AccessoryNote entity class
 */

import moment from 'moment'

/**
 * AccessoryNoteFactory
 * returns AccessoryNote entity class
 *
 * @class AccessoryNoteFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.AccessoryNote} class
 *
 * @ngdoc factory
 * @name mwApp.factory:AccessoryNoteFactory
 */
/* @ngInject */
export default function AccessoryNoteFactory ($sce, Type, Entity) {
  /* === AccessoryNote class === */

  /**
   * AccessoryNote model
   *
   * @class AccessoryNote
   * @classdesc AccessoryNote model
   * @memberof models
   * @see models
   * @extends models.Entity
   * @return {models.AccessoryNote} AccessoryNote entity
   */
  function AccessoryNote () {
    var obj = Entity.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  AccessoryNote.prototype = Object.create(Entity.prototype)
  AccessoryNote.prototype.constructor = AccessoryNote

  /* === Note instance methods & fields === */

  Object.assign(AccessoryNote.prototype, {

    /**
     * instance fields
     *
     * @memberof models.AccessoryNote#
     * @type {Object}
     */
    _fields: {
      id: Number,
      accessoryNoteId: Number,
      accessories: [{
        id: Number,
        name: String
      }],
      createdAt: moment,
      description: Type(String('')),
      entityChanged: Boolean,
      status: String,
      type: 'Accessory Purchasing'
    },

    /**
     * url template
     *
     * @memberof models.AccessoryNote#
     * @type {String}
     */
    _urlTemplate: 'api/subscribers/{{subscriber.id}}/accessory-notes/{{::accessoryNoteId}}',

    /**
     * public url template
     *
     * @memberof models.AccessoryNote#
     * @type {String}
     */
    _publicUrlTemplate: 'subscribers/{{subscriber.id}}/accessory-notes/{{::id}}',

    /**
     * Prepare note
     *
     * @memberof models.Note#
     * @override
     */
    _prepare: function () {
      this.id = this.accessoryNoteId
      this._trust()
    },

    /**
     * Object note
     *
     * @memberof models.Note#
     * @override
     */
    _object: function () {
      if (this.$processed && this.status === 'NOT_PROCESSED' && this.description === 'Awaiting Reaction') {
        this.description = 'Processed'
      }
      if (!this.$processed && this.status === 'PROCESSED' && this.description === 'Processed') {
        this.description = 'Awaiting Reaction'
      }
      if (this.status !== 'CANCELLED') {
        this.status = this.$processed ? 'PROCESSED' : 'NOT_PROCESSED'
      }
      return Entity.prototype._object.apply(this, arguments)
    },

    /**
     * Create new field with trusted HTML description
     *
     * @memberof models.Note#
     * @return {models.Note} this
     */
    _trust: function () {
      this.descriptionHtml = this.description ? $sce.trustAsHtml(this.description) : $sce.trustAsHtml('')
      return this
    }
  })

  /* === Note static methods & fields === */

  // copy all static methods from Entity class
  Object.assign(AccessoryNote, Entity)
  AccessoryNote._name = 'AccessoryNote'
  AccessoryNote.init()

  // permissions
  AccessoryNote.access = {
    view: 'viewSubscriberNote',
    create: 'createSubscriberNote',
    edit: 'editSubscriberNote'
  }

  return AccessoryNote
}
